import type { UsageReportV2 } from '@vy/types';
import { useMemo } from 'react';
import type { FilterLineType } from '../../../../components/new-design/vyTableFilter';
import { applyUsageReportV2Filters } from '../utils/apply-usage-report-v2-filters';
import { applyUsageReportV2Search } from '../utils/apply-usage-report-v2-search';
import { notDefined } from '@vy/null';

export function useFilteredUsageReportV2(
  report: UsageReportV2 | undefined,
  filters: FilterLineType[],
  searchText: string | null | undefined,
): UsageReportV2 | undefined {
  return useMemo(() => {
    if (notDefined(report)) {
      return undefined;
    }

    const afterFilters = applyUsageReportV2Filters(report.reportItems, filters);
    const afterSearch = applyUsageReportV2Search(afterFilters, searchText);

    return { ...report, reportItems: afterSearch };
  }, [report, filters, searchText]);
}
